import React, { useEffect } from 'react';
import { ActivityIndicator } from '@/components/activity-indicator';
import {
  EmployeeContactInfo_NotificationSettingsQuery,
  EmployeeContactInfo_NotificationSettingsQueryVariables,
} from '@/types';
import {
  EmployeeNotificationsActionSheet,
  NOTIFICATION_FIELDS_FRAGMENT,
} from '@/components/restaurant/employee-notifications-action-sheet';
import { gql } from '@apollo/client';
import { SCREEN_PADDING } from '@/styles';
import { StyleSheet, View } from 'react-native';
import { useToasts } from '@/contexts/toast-context';
import { useUserContext } from '@/contexts/user-context';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';

export const NOTIFICATION_SETTINGS_QUERY = gql`
  query EmployeeContactInfo_NotificationSettings(
    $employeeUUID: uuid!
    $chatUUID: uuid!
  ) {
    employees_by_pk(uuid: $employeeUUID) {
      chats_employees(where: { chat_uuid: { _eq: $chatUUID } }) {
        uuid
        show_app_payments_tab
        chat {
          show_app_payments_tab
          uuid
        }
      }
      contact_info {
        ...NotificationFields
      }
      uuid
    }
  }

  ${NOTIFICATION_FIELDS_FRAGMENT}
`;

interface Props {
  employeeUUID: string;
}

export const EmployeeNotificationsComponent: React.FC<Props> = ({
  employeeUUID,
}) => {
  const { showErrorToast } = useToasts();
  const { selectedRestaurantRelationship } = useUserContext();
  const { data, error, hasResponse } = useWrappedQuery<
    EmployeeContactInfo_NotificationSettingsQuery,
    EmployeeContactInfo_NotificationSettingsQueryVariables
  >(NOTIFICATION_SETTINGS_QUERY, {
    variables: {
      chatUUID: selectedRestaurantRelationship.chatUUIDs[0],
      employeeUUID: employeeUUID,
    },
  });

  useEffect(() => {
    if (error) {
      showErrorToast();
    }
  }, [error, showErrorToast]);

  return hasResponse &&
    data?.employees_by_pk?.contact_info &&
    data.employees_by_pk?.chats_employees[0] ? (
    <EmployeeNotificationsActionSheet
      initialNotificationSettings={data.employees_by_pk.contact_info}
    />
  ) : (
    <View style={styles.loadingIndicator}>
      <ActivityIndicator testID="loading-indicator" />
    </View>
  );
};

const styles = StyleSheet.create({
  loadingIndicator: {
    marginTop: SCREEN_PADDING,
  },
});
